var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size lg_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis maintit" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("FIELD.KNOWLEDGE.SEE.DETAILS")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "view_cont" }, [
              _c("dl", { staticClass: "view_subject" }, [
                _c("dt", { staticClass: "subject qna_view" }, [
                  "Y" === _vm.question.urgentYn
                    ? _c("em", { staticClass: "textcolor_urgent" }, [
                        _vm._v(
                          "\n                                    [" +
                            _vm._s(_vm.$t("FIELD.GLOBAL.URGENT")) +
                            "]\n                                "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.question.title) +
                      "\n                                "
                  ),
                  _c("span", { staticClass: "in_date" }, [
                    _vm._v(_vm._s(_vm.question.regDt))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "view_question" }, [
                !_vm.isNull(_vm.question.ascAccount)
                  ? _c("dl", { staticClass: "dl_view" }, [
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t("FIELD.USER.ACCOUNT.NO")))
                      ]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.question.ascAccount))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isNull(_vm.question.questionId)
                  ? _c("dl", { staticClass: "dl_view" }, [
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.QUESTION.ID")))
                      ]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.question.questionId))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isNull(_vm.question.inquiryTypeNm)
                  ? _c("dl", { staticClass: "dl_view" }, [
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY")))
                      ]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.question.inquiryTypeNm))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isNull(_vm.question.modelCd)
                  ? _c("dl", { staticClass: "dl_view" }, [
                      _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.MODEL")))]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.question.modelCd))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isNull(_vm.question.prdCategoryNm)
                  ? _c("dl", { staticClass: "dl_view" }, [
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))
                      ]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.question.prdCategoryNm))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isNull(_vm.question.repairType) ||
                !_vm.isNull(_vm.question.serialNumber)
                  ? _c("dl", { staticClass: "dl_view" }, [
                      !_vm.isNull(_vm.question.repairType)
                        ? _c("dt", [
                            _vm._v(_vm._s(_vm.$t("FIELD.QNA.REPAIR.TYPE")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isNull(_vm.question.repairType)
                        ? _c("dd", [_vm._v(_vm._s(_vm.question.repairType))])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isNull(_vm.question.serialNumber)
                        ? _c("dt", [
                            _vm._v(_vm._s(_vm.$t("FIELD.QNA.SERIAL.NUMBER")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isNull(_vm.question.serialNumber)
                        ? _c("dd", [_vm._v(_vm._s(_vm.question.serialNumber))])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isNull(_vm.question.partsNumber) ||
                !_vm.isNull(_vm.question.partsName)
                  ? _c("dl", { staticClass: "dl_view" }, [
                      !_vm.isNull(_vm.question.partsNumber)
                        ? _c("dt", [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.$t("FIELD.MYKNOWLEDGE.PARTS.NUMBER")
                                ) +
                                "\n                                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isNull(_vm.question.partsNumber)
                        ? _c("dd", [_vm._v(_vm._s(_vm.question.partsNumber))])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isNull(_vm.question.partsName)
                        ? _c("dt", [
                            _vm._v(
                              _vm._s(_vm.$t("FIELD.MYKNOWLEDGE.PARTS.NAME"))
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isNull(_vm.question.partsName)
                        ? _c("dd", [_vm._v(_vm._s(_vm.question.partsName))])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isNull(_vm.question.svcOrder) ||
                !_vm.isNull(_vm.question.mckImei)
                  ? _c("dl", { staticClass: "dl_view" }, [
                      !_vm.isNull(_vm.question.svcOrder)
                        ? _c("dt", [
                            _vm._v(_vm._s(_vm.$t("FIELD.QNA.SVC.ORDER")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isNull(_vm.question.svcOrder)
                        ? _c("dd", [_vm._v(_vm._s(_vm.question.svcOrder))])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isNull(_vm.question.mckImei)
                        ? _c("dt", [
                            _vm._v(_vm._s(_vm.$t("FIELD.MYKNOWLEDGE.IMEI")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isNull(_vm.question.mckImei)
                        ? _c("dd", [_vm._v(_vm._s(_vm.question.mckImei))])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isNull(_vm.question.requiredDt)
                  ? _c("dl", { staticClass: "dl_view" }, [
                      _c("dt", [
                        _vm._v(
                          _vm._s(_vm.$t("FIELD.GLOBAL.ANSWER.REQUIRED.DATE"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("dd", [_vm._v(_vm._s(_vm.question.requiredDt))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isNull(_vm.question.questionDesc)
                  ? _c("dl", { staticClass: "dl_view" }, [
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.QNA.DESC")))
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.stripHtml(_vm.question.questionDesc)
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "in_btn_wrap" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn_sm_white",
                              attrs: { href: "javascript:" },
                              on: {
                                click: function($event) {
                                  return _vm.translationPop("question")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(_vm.$t("FIELD.GLOBAL.TRANSLATION")) +
                                  "\n                                        "
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                0 < _vm.questionAttach.length && _vm.delay
                  ? _c("dl", { staticClass: "dl_view" }, [
                      _c("dt", [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ATTACHMENT")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "dd",
                        [
                          _c("innorix-download", {
                            attrs: {
                              uploadId: "question",
                              attachList: _vm.questionAttach,
                              serviceType: _vm.serviceType
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.questionAttach.length > 0
                  ? _c("dl", { staticClass: "attachment_link" }, [
                      _c("span", [
                        _c(
                          "a",
                          {
                            staticClass: "txt_link",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function($event) {
                                return _vm.toggleLink($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                        Having trouble downloading?\n                                    "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("dd", [
                        _c(
                          "ul",
                          _vm._l(_vm.questionAttach, function(file) {
                            return _c(
                              "li",
                              { key: file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "txt_link",
                                    attrs: { href: "javascript:" },
                                    on: {
                                      click: function($event) {
                                        return _vm.getDownloadUrl(
                                          file.ENC_ATTCH_FILE_SEQ,
                                          file.ENC_TOKEN
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                " +
                                        _vm._s(file.FILE_NM) +
                                        "\n                                            "
                                    )
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                ["ACP", "PRO"].includes(_vm.result.FLOW_STATUS) &&
                _vm.loginNo === _vm.result.ANSWERER_USER_NO
                  ? _c("dl", { staticClass: "commentWrite_wrap" }, [
                      _c("dt", [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.$t("MESSAGE.QNA.WANT")) +
                            " (" +
                            _vm._s(_vm.question.regUserNm) +
                            ")\n                                    " +
                            _vm._s(_vm.$t("MESSAGE.QNA.BEFORE")) +
                            "?\n                                "
                        )
                      ]),
                      _vm._v(" "),
                      "PRO" === _vm.result.FLOW_STATUS
                        ? _c(
                            "div",
                            { staticClass: "view_qna_desc" },
                            [
                              _vm._l(_vm.commentList, function(reply) {
                                return _c(
                                  "dl",
                                  {
                                    key:
                                      _vm.pageName +
                                      reply.QUESTION_FLOW_ID +
                                      reply.COMMENT_SEQ,
                                    class:
                                      "Y" === reply.ANSWERER_YN ? "" : "reply"
                                  },
                                  [
                                    _c("dt", [
                                      "Y" === reply.ANSWERER_YN
                                        ? _c(
                                            "span",
                                            { staticClass: "item_status" },
                                            [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "MESSAGE.QNA.EXP.ANS"
                                                    )
                                                  ) +
                                                  "\n                                            "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "item_name" }, [
                                        _vm._v(_vm._s(reply.REG_USER_NAME))
                                      ]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "item_date" }, [
                                        _vm._v(_vm._s(reply.REG_DT))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("dd", [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(reply.MESSAGE) +
                                          "\n                                            "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "in_btn_wrap" },
                                        [
                                          !_vm.isMobile()
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "btn_sm_white",
                                                  attrs: {
                                                    href: "javascript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.translationPop(
                                                        reply.MESSAGE
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "FIELD.GLOBAL.TRANSLATION"
                                                        )
                                                      ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              "PRO" === _vm.result.FLOW_STATUS
                                ? _c(
                                    "dl",
                                    { staticClass: "reply_write_wrap" },
                                    [
                                      _c(
                                        "dt",
                                        {
                                          attrs: {
                                            "data-input-type": "textarea"
                                          }
                                        },
                                        [
                                          _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.comment,
                                                expression: "comment"
                                              }
                                            ],
                                            staticClass: "textarea_ty w100p",
                                            attrs: { maxlength: "3000" },
                                            domProps: { value: _vm.comment },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.comment =
                                                  $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "textarea_counter" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.commentLength) +
                                                  "/3000"
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("dd", [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "btn_reply",
                                            attrs: { href: "javascript:" },
                                            on: {
                                              click: function($event) {
                                                return _vm.replyComment(
                                                  "replyComment"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "BUTTON.MYKNOWLEDGE.REPLY"
                                                  )
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      "ACP" === _vm.result.FLOW_STATUS
                        ? _c(
                            "dd",
                            { attrs: { "data-input-type": "textarea" } },
                            [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.comment,
                                    expression: "comment"
                                  }
                                ],
                                staticClass: "textarea_ty w100p",
                                attrs: { maxlength: "3000" },
                                domProps: { value: _vm.comment },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.comment = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "textarea_counter" }, [
                                _vm._v(_vm._s(_vm.commentLength) + "/3000")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      "ACP" === _vm.result.FLOW_STATUS
                        ? _c("dd", { staticClass: "btn" }, [
                            _c(
                              "a",
                              {
                                staticClass: "btn_reply",
                                attrs: { href: "javascript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.replyComment("firstComment")
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(_vm.$t("BUTTON.GLOBAL.SEND")) +
                                    "\n                                    "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !["REG", "WFA"].includes(_vm.result.FLOW_STATUS)
                  ? _c("section", { staticClass: "answer_question_wrap" }, [
                      _c("p", { staticClass: "sec_title" }, [
                        _c("em", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.QNA.ANS")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("dl", { staticClass: "dl_write" }, [
                        _c("dt", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.QNA.PRIVAT")))
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c("label", { staticClass: "checkbox-wrap" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.openYn,
                                  expression: "openYn"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                "true-value": "N",
                                "false-value": "Y"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.openYn)
                                  ? _vm._i(_vm.openYn, null) > -1
                                  : _vm._q(_vm.openYn, "N")
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.openYn,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? "N" : "Y"
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.openYn = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.openYn = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.openYn = $$c
                                  }
                                }
                              }
                            }),
                            _c("i", { staticClass: "check-icon" })
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "dl",
                        { staticClass: "dl_write" },
                        [
                          _c("dt", [
                            _vm._v(_vm._s(_vm.$t("FIELD.FAST.ANSWER")))
                          ]),
                          _vm._v(" "),
                          _c("cross-editor", {
                            attrs: {
                              editorId: _vm.pageName,
                              editorData: _vm.stripHtml(
                                _vm.nvl(_vm.proSolution.ANSDESC)
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("dl", { staticClass: "dl_write" }, [
                        _c("dt", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ATTACHMENT")))
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "attachment_wrap" },
                            [
                              _c("innorix-upload", {
                                attrs: {
                                  uploadId: "proSolution",
                                  id: "proSolution",
                                  name: "proSolution",
                                  serviceType: _vm.serviceType,
                                  onlyUpload: _vm.onlyUpload,
                                  attachList: _vm.proSolutionAttach
                                },
                                on: { files: _vm.setFiles }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_wrap_full topLine" }, [
              _c("div", { staticClass: "btn_right pc_only" }, [
                ["ACP", "PRO"].includes(_vm.result.FLOW_STATUS)
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_white",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.save("Draft")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("BUTTON.GLOBAL.SAVEDRAFT")) +
                            "\n                            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                ["ANS", "EVL", "END", "REQ"].includes(_vm.result.FLOW_STATUS) &&
                _vm.loginNo === _vm.proSolution.REGUSERNO
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_white",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.save("Draft")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("FIELD.GLOBAL.MODIFY")) +
                            "\n                            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                ["ACP", "PRO"].includes(_vm.result.FLOW_STATUS) &&
                "4" != _vm.deptLevelCd
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_white",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.forward("U")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("BUTTON.QNA.FORWARD.UP")) +
                            "\n                            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                ["ACP", "PRO"].includes(_vm.result.FLOW_STATUS) &&
                "1" != _vm.deptLevelCd
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_white",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.forward("S")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("BUTTON.QNA.FORWARD.TO")) +
                            "\n                            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                ["ACP", "PRO"].includes(_vm.result.FLOW_STATUS)
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_blue",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.save("save")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("FIELD.FAST.ANSWER")) +
                            "\n                            "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                ["REG", "WFA"].includes(_vm.result.FLOW_STATUS)
                  ? _c(
                      "a",
                      {
                        staticClass: "btn_blue",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.acceptQuestion(_vm.question.questionId)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t("BUTTON.GLOBAL.ACCEPT")) +
                            "\n                            "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58cdbdc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58cdbdc0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/faq/popup/answerDetailPopup.vue
// module id = yze+
// module chunks = 0